/* eslint-disable no-nested-ternary */
import {
    Button, Input, Modal, ModalBody, ModalHeader,
} from 'appkit-react';

import '../styles/create-new-folder.scss';

const CreateNewFolder = ({
    folderName, inputHandler, onBlurHandler, folderNameError, folderNameIsValid, visible, setVisible, onSave, loading, isFolderNameExist,
}) => {
    const getErrorMsg = () => {
        let msg = '';
        if (folderNameError) {
            msg = 'Folder name is required.';
        } else if (folderNameIsValid) {
            msg = `Invalid folder name. A folder name can't contain - ${'\\ / : * ? < > | "'}`;
        } else if (isFolderNameExist) {
            msg = 'Folder name already exist.';
        }
        return msg;
    };

    return (
        <div>
            <Modal
                className="add-and-edit-modal"
                visible={visible}
                onCancel={() => { setVisible(false); }}
                style={{ marginTop: '10rem' }}
                backdropClosable={false}
            >
                <ModalHeader>
                    <div className="a-modal-header">
                        <div className="modal-title-left">
                            <div className="modal-title">Create folder</div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div className="create-folder-modal-container">
                        <div className="create-folder-form-input-right-col">
                            <form onSubmit={onSave}>
                                <Input
                                    placeholder="Enter folder name"
                                    type="text"
                                    name="folderName"
                                    value={folderName}
                                    hasError={folderNameError || folderNameIsValid || isFolderNameExist}
                                    errMsg={getErrorMsg()}
                                    onChange={e => inputHandler(e)}
                                    onBlur={onBlurHandler}
                                    style={{ marginBottom: '1rem' }}
                                />
                                <div style={{ width: 'fit-content', marginLeft: 'auto' }}>
                                    <Button kind="secondary" onClick={() => { setVisible(false); }} size="lg"> Cancel </Button>
                                    <Button
                                        type="submit"
                                        kind="primary"
                                        size="lg"
                                        isLoading={loading}
                                        disabled={folderName === ''}
                                        style={{ marginLeft: '0.9rem' }}
                                    >
                                        Create
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default CreateNewFolder;
